import React from 'react';
import Spinner from 'react-spinkit';
import {connect} from "react-redux";
import {compose} from "redux";
import {Icon, Popover} from "antd";
import {getUsers} from "../../actions/users";
import {withLoading2} from "./deferLoaderHoc";
import ContactCard from "./ContactCard";
import * as R from "ramda";
import * as PropTypes from "prop-types";

export class _UserInfoCustom extends React.PureComponent {
  render() {
    const { resource: { id, ...user } } = this.props;

    if (!id) return null;

    const { dataItems = ['name'] } = this.props;
    // Build child only if their key is present in the data items prop
    const filterDisplay = (key, value) => dataItems.includes(key) ? value : null;
    const name = user.name && filterDisplay('name', <React.Fragment>{user.name}</React.Fragment>);
    const companyname = user.companyname && filterDisplay('companyname', <React.Fragment>{user.companyname}</React.Fragment>);
    const email = filterDisplay('email', <span style={{ fontWeight: 'initial' }}>{user.emailaddress}</span>);
    const safetrim = a => a && typeof(a) === "string" ? a.trim() : a;
    const display = safetrim(user.name) ? safetrim(user.companyname) ? <React.Fragment>{companyname} - {name}</React.Fragment> : name : email;

    return (
      <span>
        <Popover
          content={
            <ContactCard id={id}/>
          }
        >
          <span className='user-info-small'>
            <Icon type='idcard'/>
            {display}
          </span>
        </Popover>
      </span>
    );
  }
}

_UserInfoCustom.propTypes = {
  resource: PropTypes.object.isRequired,
  dataItems: PropTypes.arrayOf(PropTypes.string),
};

const mapState = (state, ownProps) => {
  const dataPath = R.append(ownProps.id, (ownProps.dataPath || ['users', 'data']));
  const user = R.path(dataPath, state);
  // Attempt to retrieve an item's resource data, but fall back if it's a pure resource without cache metadata
  const user_resource = user.resource || user;
  if (!user) return { resource: { id: ownProps.id }, cache: { loading: true } };
  return {
    resource: {
      id: ownProps.id,
      ...user_resource,
    },
    cache: {
      loading: false
    }
  };
};

export const UserInfoCustom = compose(
  connect(mapState),
  withLoading2(
    ({ resource: { id } }, dispatch) => dispatch(getUsers(id)),
    () => <Spinner name='line-scale'/>,
    null
  )
)(_UserInfoCustom);

const mapStateFromResource = (state, ownProps) => {
  // Attempt to retrieve an item's resource data, but fall back if it's a pure resource without cache metadata
  const user_resource = ownProps.resource;
  return {
    resource: {
      id: ownProps.id,
      ...user_resource,
    },
    cache: {
      loading: false
    }
  };
};

export const UserInfoCustomFromResource = compose(
  connect(mapStateFromResource),
)(_UserInfoCustom);

UserInfoCustomFromResource.propTypes = {
  id: PropTypes.string.isRequired,
  dataItems: PropTypes.arrayOf(PropTypes.string),
  resource: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Boilerplate/UserInfoCustom.js